import { Container, Navbar, NavbarText } from "reactstrap";

import Toggle from "../darkmode/ToggleButton";

function NavbarTop({ theme, toggleTheme }) {
  return (
    <Navbar className="bg-gradient-ucla" dark expand="md">
      <Container className="navbar">
        <img
          alt="MQE Quant Lab Logo"
          className="mqe-logo"
          src={require("../assets/logo.png")}
        />

        <div className="d-flex align-items-center">
          <Toggle theme={theme} toggleTheme={toggleTheme} />
          <NavbarText>
            Forecasting <br />
            Laboratory<sub> Est. 2021</sub>
          </NavbarText>
        </div>
      </Container>
    </Navbar>
  );
}

export default NavbarTop;
